import '.a7{position:relative;}.ssr-plugin'
import '.em{display:inline-flex;}.ssr-plugin'
import '.e2{width:32px;}.ssr-plugin'
import '.ff{height:20px;}.ssr-plugin'
import '.hv{padding:2px;}.ssr-plugin'
import '.eq{outline:none;}.ssr-plugin'
import '.j{border:none;}.ssr-plugin'
import '.a5{width:16px;}.ssr-plugin'
import '.a4{height:16px;}.ssr-plugin'
import { radius } from '../../utils/radius.js'
import { colors } from '../../tokens/colors.js'
import { styled, Style } from 'inlines'
import { Text } from '../Text/index.js'
import { LabelDescription } from '../LabelDescription/index.js'

type SwitchInputProps = {
  value?: boolean
  onChange: (value: boolean) => void
  disabled?: boolean
  description?: string
  state?: string
  label?: string
  style?: Style
}

const SwitchInput = ({
  value,
  onChange,
  disabled,
  label,
  description,
  state,
  style,
}: SwitchInputProps) => {
  return (
    <LabelDescription label={label} description={description}>
      <label
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          cursor: 'pointer',
          userSelect: 'none',
          ...(disabled && { cursor: 'not-allowed' }),
        }}
      >
        <styled.div className="a7 em e2 ff hv eq j"
          data-disabled={disabled ? disabled : undefined}
          data-checked={value ? value : undefined}
          style={{
            borderRadius: radius.full,
            background: colors.neutral20Adjusted,
            '&[data-checked]': {
              background: colors.neutral100,
            },
            '&:has(:focus-visible):not([data-disabled])': {
              outline: `4px solid ${colors.neutral20}`,
            },
            '&[data-error]': {
              background: colors.red100,
            },
            '&[data-error]:has(:focus-visible):not([data-disabled])': {
              outline: `4px solid ${colors.red60}`,
            },
            '&[data-disabled]': {
              background: colors.neutral20Adjusted,
            },
            // transition: 'all 150ms ease-out',
            ...style,
          }}
        >
          <styled.div className="a5 a4"
            style={{
              borderRadius: radius.full,
              background: colors.neutralInverted100,
              ...(value && {
                marginLeft: 12,
                background: colors.neutralInverted100,
              }),
              ...(disabled && {
                background: colors.neutralInverted60,
              }),
              // transition: 'all 150ms ease-out',
            }}
          />
          <input
            style={{
              position: 'absolute',
              width: 1,
              height: 1,
              padding: 0,
              margin: -1,
              overflow: 'hidden',
              clip: 'rect(0, 0, 0, 0)',
              whiteSpace: 'nowrap',
              borderWidth: 0,
            }}
            type="checkbox"
            checked={value ?? false}
            onChange={() => {
              if (disabled) return

              onChange(!value)
            }}
            disabled={disabled}
          />
        </styled.div>
        {state && (
          <Text
            variant="display-regular"
            color={value && !disabled ? 'neutral100' : 'neutral60'}
          >
            {state}
          </Text>
        )}
      </label>
    </LabelDescription>
  )
}

export type { SwitchInputProps }
export { SwitchInput }
